<template>
  <div class="container">
    <div class="block">
      <div class="content-inner-wrapper">
        <van-form label-width="1rem" label-align="right">
          <van-field label="订单编号">
            <template #input>
              {{ order.id }}
            </template>
          </van-field>
          <van-field label="创建时间">
            <template #input>
              {{ order.create_time | formatTime }}
            </template>
          </van-field>
          <van-field label="订单内容">
            <template #input>
              {{ order.operation_type | orderType }} 云服x{{
                order.buy_count || list.length
              }}
            </template>
          </van-field>
          <van-field label="时长">
            <template #input>
              {{ order.day }}天<van-tag
                plain
                :type="order.state == 2 ? 'success' : 'warning'"
                >{{ order.state | orderState }}</van-tag
              >
            </template>
          </van-field>
        </van-form>
        <h3>云服列表</h3>
        <my-table :tableData="list" :tableField="dataField">
          <template slot-scope="scope" slot="default">
            <span v-if="scope.row.key == 'room_type'">
              {{ scope.row.value | roomType }}
            </span>
            <span v-else-if="scope.row.key == 'player_max'">
              {{ scope.row.value }}人
            </span>
          </template>
        </my-table>
        <van-form label-width="3rem" label-align="right">
          <van-field label="总价：">
            <template #input> ¥{{ order.ori_money }} </template>
          </van-field>
          <van-field label="优惠：">
            <template #input> ¥{{ order.subMoney }} </template>
          </van-field>
          <van-field class="realMoney" label="实付款：">
            <template #input> ¥{{ order.money }} </template>
          </van-field>
        </van-form>
      </div>
    </div>
  </div>
</template>
<script>
import mixins from '../../mixins/orderDetails.mixins';
import MyTable from '../../components/m/MyTable.vue';
export default {
  components: {
    MyTable,
  },
  mixins: [mixins],
  data() {
    return {
      dataField: [
        { prop: 'room_id', label: '云服id' },
        { prop: '', label: '' },
        { prop: 'player_max', label: '云服规格' },
        { prop: 'room_type', label: '云服类型' },
      ],
    };
  },
};
</script>
<style src="../../style/common-m.scss" lang="scss" scoped></style>
<style lang="scss" scoped>
.van-tag {
  margin-left: 12px;
}
</style>
